import { Student, useStudentNextYearTuitionAmountQuery } from "../../../../Utilities";
import { ModelFormat } from "../../../Format";

export const tableColumns = ["icon", "studentName", "currentYear", "nextYear", "tuition", "isEnrolling"];

export const tableColumnWidths = {
	icon: "3rem",
	studentName: "minmax(10rem, 1fr)",
};

export function useStudentTuitionText(studentID: Student["id"]) {
	const { loading: loadingTuition, data: tuitionData } = useStudentNextYearTuitionAmountQuery({
		variables: { studentID },
	});
	const tuition = tuitionData?.studentNextYearTuitionAmount ?? 0;
	if (loadingTuition) {
		return "...";
	}
	if (tuition > 0) {
		return ModelFormat.money(tuition);
	}
	return "—";
}
